import { SiteLayout } from "@/components/site/SiteLayout";
import { PageSEO } from "@/components/site/PageSEO";
import { CTASection } from "@/components/site/CTASection";
import { ResourceHero } from "@/components/site/ResourceHero";
import NoticeLookupTool from "@/components/NoticeLookupTool";
import { brand } from "@/data/site/brand";
import { irsNotices } from "@/data/irsNotices";
import { stockImages } from "@/data/site/stockImages";

const NoticeLookup = () => (
  <SiteLayout>
    <PageSEO
      title="IRS Notice Lookup Tool"
      description="Find your IRS notice fast. Search by notice number or answer a few questions to identify what you received and what to do about it."
      path="/resources/notice-lookup"
      image={stockImages.noticeEnvelope.src}
    />
    <ResourceHero
      breadcrumbs={[
        { name: "Home", href: "/" },
        { name: "Resources", href: "/resources" },
        { name: "Notice Lookup" },
      ]}
      eyebrow="Interactive tool"
      title="Find your IRS notice"
      summary="Type the notice number from the top-right corner of your letter, or answer two quick questions. We'll show you what it means and what to do next."
      facts={[
        { label: "Notices indexed", value: irsNotices.length },
        { label: "Time", value: "≈ 30 seconds" },
        { label: "Cost", value: "Free" },
      ]}
      background="noticeEnvelope"
    />


    <section className="py-12 lg:py-16 bg-white">
      <div className="container mx-auto px-4 max-w-4xl">
        <NoticeLookupTool phoneNumber={brand.phone} />
      </div>
    </section>

    <CTASection />
  </SiteLayout>
);

export default NoticeLookup;
